var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 26C13.9 26 13.01 26.9 13.01 28C13.01 29.1 13.9 30 15 30C16.1 30 17 29.1 17 28C17 26.9 16.1 26 15 26ZM9 10V12H11L14.6 19.59L13.25 22.04C13.09 22.32 13 22.65 13 23C13 24.1 13.9 25 15 25H27V23H15.42C15.28 23 15.17 22.89 15.17 22.75L15.2 22.63L16.1 21H23.55C24.3 21 24.96 20.59 25.3 19.97L28.88 13.48C28.96 13.34 29 13.17 29 13C29 12.45 28.55 12 28 12H13.21L12.27 10H9ZM25 26C23.9 26 23.01 26.9 23.01 28C23.01 29.1 23.9 30 25 30C26.1 30 27 29.1 27 28C27 26.9 26.1 26 25 26Z",
    fill: "#16BDCA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercados);
export default __webpack_public_path__ + "static/media/mercados.f9638611a00d1ccd5bbf13b6b9f08e9b.svg";
export { ForwardRef as ReactComponent };